import { MainContent, Subhead } from '@growtherapy/sprout-ui';

import { ProviderAvatarWrapper as NewProviderAvatar } from './ProviderAvatarWrapper';

export type IntroRoomContentProps = {
  rightContent: React.ReactNode;
  footerContent?: React.ReactNode;
  providerAvatarSectionComponent: typeof NewProviderAvatar;
  title: string;
};

/**
 * Presentational component for the intro room content. This UI does NOT support
 * the pre-rebrand design system.
 */
export function IntroRoomContent({
  providerAvatarSectionComponent: ProviderAvatarComponent,
  rightContent,
  footerContent,
  title,
}: IntroRoomContentProps) {
  return (
    <div className='w-full h-full flex flex-col'>
      <div className='grow sm:py-12 sm:px-14 overflow-y-auto grid [@media(min-height:1000px)]:place-items-center'>
        <MainContent variant='twoColumnWithHeader' className='max-w-[1400px]'>
          <MainContent.Header>
            <span className='hidden sm:block'>{title}</span>
          </MainContent.Header>
          <MainContent.Left>
            <Subhead.Large
              as='h1'
              className='text-center rebrand:text-2xlarge rebrand:text-neutral-900 sm:hidden mb-11 px-350'
            >
              {title}
            </Subhead.Large>
            <ProviderAvatarComponent />
          </MainContent.Left>
          <MainContent.Right>{rightContent}</MainContent.Right>
        </MainContent>
      </div>
      {footerContent}
    </div>
  );
}
